import type { Logger } from "@expert/logging";
import type { KyInstance } from "ky";

import type { SalesAnalyticsDispatcher } from "../sales-context/SalesContext.types";
import type { SalesProvider } from "../types";

export type ProductEnrollmentStatus = "FAILURE" | "INITIALIZED" | "PENDING" | "SUCCESS";

export type GetProductOfferResponse = {
    enrollmentStatus: ProductEnrollmentStatus;
    productOfferId: string;
};

const getProvider = (salesProvider: SalesProvider) => {
    switch (salesProvider) {
        case "asp":
            return "ASP";
        case "expert-sales":
            return "EXPERTSALES";
        default:
            return "Unknown";
    }
};

export const getProductOffer = async (
    client: KyInstance,
    logger: Logger,
    dispatcher: SalesAnalyticsDispatcher,
    productOfferId: string,
    partner: string,
    salesProvider: SalesProvider,
    sessionId: string,
): Promise<GetProductOfferResponse> => {
    const childLogger = logger.child({ module: "getProductOffer", productOfferId, partner, salesProvider });
    try {
        childLogger.info({ productOfferId, partner, salesProvider }, "Fetching product offer");
        const response = await client
            .get(`v3/product-offer/${partner}/${productOfferId}/${salesProvider}?sessionId=${sessionId}`, {
                retry: 0,
            })
            .json<GetProductOfferResponse>();
        if (response.enrollmentStatus === "SUCCESS" || response.enrollmentStatus === "FAILURE") {
            void dispatcher.dispatchBusinessEvent(`${getProvider(salesProvider)}EnrollmentEventReceived`, {
                productOfferId: response.productOfferId,
                enrollmentStatus: response.enrollmentStatus,
            });
        }
        return response;
    } catch (error: unknown) {
        childLogger.warn({ error }, "product offer poll failed");
        throw error;
    }
};
